export function hasValue(candidate) {
    return candidate !== undefined && candidate !== null;
}
